import PropTypes from 'prop-types';
import { loaderContextShape } from "./LoaderContext";

/**
 * @deprecated
 * @see LoaderContext.js -> loaderContextShape
 */
var shape = PropTypes.shape(loaderContextShape).isRequired;
export default shape;